import React, { useState } from 'react';
import { Form, Input, Button, InputNumber, Card, Typography, message as antdMessage, Alert } from 'antd';
import { addRootToBomAPI, AddRootPayload, AddRootApiResponse, ProcessedBomData } from '../../services/api';

const { Title } = Typography;

interface RootProductFormProps {
  currentBomData: ProcessedBomData | null;
  onRootAdded: (data: AddRootApiResponse) => void;
}

const RootProductForm: React.FC<RootProductFormProps> = ({ currentBomData, onRootAdded }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onFinish = async (values: any) => {
    if (!currentBomData || !currentBomData.dataframeJson) {
      antdMessage.error('No BOM data available to add root to.');
      return;
    }
    setLoading(true);
    setError(null);
    const payload: AddRootPayload = {
      name: values.productName,
      time: values.productionTime,
      currentBomDataJson: currentBomData.dataframeJson,
      currentFilename: currentBomData.filename,
    };
    try {
      const response = await addRootToBomAPI(payload);
      onRootAdded(response.data);
      antdMessage.success('Root product added successfully!');
      form.resetFields();
    } catch (err: any) {
      const apiError = err.response?.data?.detail || err.message || 'Failed to add root product.';
      setError(apiError);
      antdMessage.error(apiError);
    }
    setLoading(false);
  };

  if (!currentBomData || currentBomData.rootIndex !== null) {
    return null; // Don't show form if BOM has root or no BOM data
  }

  return (
    <Card style={{ marginTop: 24 }}>
      <Title level={4}>Stammprodukt Information</Title>
      <p>Das Stammprodukt (Tiefe 0) wurde in der Datei nicht gefunden. Bitte geben Sie die Informationen hier ein:</p>
      {error && <Alert message={error} type="error" showIcon closable style={{ marginBottom: 16 }} onClose={() => setError(null)} />}
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Produktname (Objektkurztext):"
          name="productName"
          rules={[{ required: true, message: 'Please input the product name!' }]}
        >
          <Input placeholder="Produktname eingeben" />
        </Form.Item>
        <Form.Item
          label="Produktionszeit (Eigenfertigungs-/Planlieferzeit):"
          name="productionTime"
          rules={[{ required: true, message: 'Please input the production time!' }]}
        >
          <InputNumber min={0} step={1} placeholder="Produktionszeit eingeben" style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Stammprodukt hinzufügen
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default RootProductForm;